// extracted by mini-css-extract-plugin
export var active = "Course-module__active___CLvX6";
export var content = "Course-module__content___ih9T-";
export var courseDetails = "Course-module__courseDetails___NcpBc";
export var courseDetailsContent = "Course-module__courseDetailsContent___Wm+e2";
export var courseDetailsHeader = "Course-module__courseDetailsHeader___8oYwg";
export var currentLesson = "Course-module__currentLesson___3w+gl";
export var headerBackground = "Course-module__headerBackground___yX2xR";
export var headerContent = "Course-module__headerContent___ezxWZ";
export var image = "Course-module__image___YFxRY";
export var lesson = "Course-module__lesson___jDXsU";
export var lessonDetails = "Course-module__lessonDetails___gtKZY";
export var meta = "Course-module__meta___qXM27";
export var minEstimate = "Course-module__minEstimate___6DaeB";
export var moreCourses = "Course-module__moreCourses___fRg7v";
export var otherCoursesGrid = "Course-module__otherCoursesGrid___tW8qZ";
export var playContainer = "Course-module__playContainer___I-pvv";
export var section = "Course-module__section___EO7t8";
export var toc = "Course-module__toc___Metu-";
export var withBg = "Course-module__withBg___sMxO-";